var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 749,
    height: 298,
    viewBox: "0 0 749 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.465H741.837C745.446 0.465 748.372 3.39082 748.372 7V290.673C748.372 294.282 745.446 297.208 741.837 297.208H6.99998C3.3908 297.208 0.465 294.282 0.465 290.673V7.00001C0.465 3.39083 3.39082 0.465 7 0.465Z",
    fill: "#1E88E5",
    stroke: "#CFCFCF",
    strokeWidth: 0.93
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.684 219L343 297.913H499L421.684 219Z",
    fill: "#004F94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.9121 148.316L-0.000411987 227L-0.000411987 71L78.9121 148.316Z",
    fill: "#004F94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M505 0H299C299 0 361.69 69.7444 379.757 83.939C397.825 98.1335 416.714 86.6687 420.821 83.939C424.927 81.2093 505 0 505 0Z",
    fill: "#004F94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M386.345 124.722L507.784 2.36449C509.286 0.851149 511.33 0 513.462 0H741C745.418 0 749 3.58172 749 7.99999V289.67C749 294.088 745.418 297.67 741 297.67H507.752C505.519 297.67 503.388 296.737 501.874 295.097L386.345 169.951C367.609 154.052 378.538 133.174 386.345 124.722Z",
    fill: "#004F94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightbg);
export default __webpack_public_path__ + "static/media/rightbg.568cbb0c9f93f0fde7080e341eaa9b97.svg";
export { ForwardRef as ReactComponent };